import { Coffee, UtensilsCrossed, Apple, Cookie, Moon } from 'lucide-react';

// Moments de la journée (termes nutrition pro FR)
export const MEALS = [
  { key: 'breakfast', fr: 'Petit-déjeuner', en: 'Breakfast', icon: Coffee },
  { key: 'lunch', fr: 'Déjeuner', en: 'Lunch', icon: UtensilsCrossed },
  { key: 'snack', fr: 'Collation', en: 'Snack', icon: Apple },
  { key: 'gouter', fr: 'Goûter', en: 'Afternoon snack', icon: Cookie },
  { key: 'dinner', fr: 'Dîner', en: 'Dinner', icon: Moon },
];

// Répartition indicative de l'objectif calorique quotidien par repas (style Yazio),
// pour afficher un "budget" par carte-repas. Purement informatif, non contraignant.
export const MEAL_SPLIT = {
  breakfast: 0.25, lunch: 0.35, snack: 0.10, gouter: 0.10, dinner: 0.30,
};

// Unités de mesure
export const UNITS = [
  { key: 'g', fr: 'g', en: 'g' },
  { key: 'ml', fr: 'ml', en: 'ml' },
  { key: 'portion', fr: 'portion', en: 'serving' },
  { key: 'piece', fr: 'pièce', en: 'piece' },
  { key: 'tranche', fr: 'tranche', en: 'slice' },
  { key: 'cas', fr: 'c. à soupe', en: 'tbsp' },
  { key: 'cac', fr: 'c. à café', en: 'tsp' },
  { key: 'poignee', fr: 'poignée', en: 'handful' },
  { key: 'tasse', fr: 'tasse', en: 'cup' },
  { key: 'verre', fr: 'verre', en: 'glass' },
  { key: 'bol', fr: 'bol', en: 'bowl' },
];

// Couleurs (charte Body-Up, cohérent avec le camembert des résultats)
export const MACRO_META = {
  calories: { color: '#E91E63', fr: 'Calories', en: 'Calories', unit: 'kcal' },
  protein: { color: '#EC4899', fr: 'Protéines', en: 'Protein', unit: 'g' },
  carbs: { color: '#FBBF24', fr: 'Glucides', en: 'Carbs', unit: 'g' },
  fat: { color: '#10B981', fr: 'Lipides', en: 'Fat', unit: 'g' },
};

export const todayStr = () => new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD (local)

// Moment du repas suggéré selon l'heure locale (pour pré-surligner la bonne carte)
export const suggestedMeal = () => {
  const h = new Date().getHours();
  if (h >= 5 && h < 10) return 'breakfast';
  if (h >= 10 && h < 14) return 'lunch';
  if (h >= 14 && h < 16) return 'snack';
  if (h >= 16 && h < 18) return 'gouter';
  return 'dinner';
};

export const addDays = (dateStr, n) => {
  const d = new Date(dateStr + 'T12:00:00');
  d.setDate(d.getDate() + n);
  return d.toLocaleDateString('en-CA');
};

export const healthLabel = (score, en) => {
  if (score == null) return { txt: en ? 'No data' : 'Aucune donnée', color: '#71717a' };
  if (score >= 80) return { txt: en ? 'Excellent' : 'Excellent', color: '#10B981' };
  if (score >= 60) return { txt: en ? 'Good' : 'Bon', color: '#84CC16' };
  if (score >= 40) return { txt: en ? 'Average' : 'Moyen', color: '#FBBF24' };
  return { txt: en ? 'To improve' : 'À améliorer', color: '#F97316' };
};

const UNIT_GRAMS = {
  g: 1, ml: 1, portion: 100, piece: 50, tranche: 30,
  cas: 15, cac: 5, poignee: 30, tasse: 240, verre: 200, bol: 250,
};

export const unitToGrams = (food, qty, unit) => {
  if (unit === 'piece' && food?.piece_g) return qty * food.piece_g;
  if (unit === 'tranche' && food?.slice_g) return qty * food.slice_g;
  return qty * (UNIT_GRAMS[unit] || 1);
};

export const scaleFood = (food, grams) => {
  const k = grams / 100;
  return {
    calories: (food.kcal || 0) * k,
    protein: (food.p || 0) * k,
    carbs: (food.c || 0) * k,
    fat: (food.f || 0) * k,
  };
};
